import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  dialog: {
    position: 'relative',
    top: '50%',
    left: '50%'
  },
  dialogtextField: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4)
  },
  dialogButton: {
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(3)
  },
  dialogDescription: {
    minHeight: 30,
    maxHeight: 100,
    overflowY: 'scroll',
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4)
  }
}));
const ScoreDialog = ({
  open,
  onClose,
  details,
  setSelectedCard,
  setAssociationCard
}) => {
  const handleClose = () => {
    setSelectedCard(-1);
    setAssociationCard(-1);
    onClose();
  };

  const classes = useStyles();
  return (
    <Dialog
      className={classes.dialog}
      aria-labelledby="score-dialog"
      fullWidth={true}
      maxWidth="sm"
      open={open}>
      <DialogTitle id="score-dialog" align="center">
        DETAILS
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.dialogDescription}>
          {Object.values(details).map((value, idx) => (
            <li key={idx}>
              {value.name} : {value.score}
            </li>
          ))}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          className={classes.dialogButton}
          color="secondary"
          size="medium"
          variant="outlined"
          onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScoreDialog;
